import React, { useState, useEffect } from "react";
import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";
import { JWT } from "../../constants/local-storage";
import { functions } from "../../constants/common-functions";

export default function AdministrationPublisher() {

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  
  
  useEffect(

      function()
      {

          functions.getObjectFromAjax(

              "/resolutionsoftwareplatform/utilisationgetsurveys",

              function(data)
              {

                  setUtilisationSurveys(data);


              }

          );

      },

      []

  );
  
  
  const [utilisationSurveys, setUtilisationSurveys] =
      useState([]);

  const [utilisationSurveyId, setUtilisationSurveyId] =
      useState(-100);

  const thisContainer = {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    paddingTop:'40px',
    height: "100vh",
	backgroundColor:'white'
  };

  const contentStyle = {
    marginLeft: "220px",
    padding: "40px",
  };

  const buttonStyle = {
    padding: "12px 20px",
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "14px",
	marginRight:"20px"
  };

  const spinnerStyle = {
    width: "40px",
    height: "40px",
    border: "4px solid #eee",
    borderTop: "4px solid #007bff",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
    marginTop: "20px"
  };

  async function handlePublishAll() {
	if(
	    utilisationSurveyId == null ||
	    utilisationSurveyId === -100
	)
	{
	    alert("Select a survey");
	    return;
	}
    setLoading(true);
    setMessage(null);

    try {
		const response = await fetch(

		    "/resolutionsoftwareplatform/utilisationsummarypublish" +

		    "?utilisationSurveyId=" +

		    utilisationSurveyId,

		    {

		        method: "POST",

		        headers:
		        {
		            Authorization:
		                "Bearer " +
		                localStorage.getItem(JWT)
		        }

		    }

		);

      const text = await response.text();
      setMessage(text);

    } catch (e) {
      console.error(e);
      setMessage("Publish failed 😬");
    }

    setLoading(false);
  }
  
  async function handlePublishOrgs() {
	if(
	    utilisationSurveyId == null ||
	    utilisationSurveyId === -100
	)
	{
	    alert("Select a survey");
	    return;
	}
     setLoading(true);
     setMessage(null);

     try {
		const response = await fetch(

		    "/resolutionsoftwareplatform/dashboard/administration/utilisation/publishsummaryorganisation" +

		    "?utilisationSurveyId=" +

		    utilisationSurveyId,

		    {

		        method: "POST",

		        headers:
		        {
		            Authorization:
		                "Bearer " +
		                localStorage.getItem(JWT)
		        }

		    }

		);

       const text = await response.text();
       setMessage(text);

     } catch (e) {
       console.error(e);
       setMessage("Publish failed 😬");
     }

     setLoading(false);
   }
  
  
  

  return (
    <div style={thisContainer}>
      <Header />
      <LeftMenu />

      <div style={contentStyle}>

        <h2 style={{ marginBottom: "20px" }}>Utilisation Summary Publish</h2>
		
		
		<div
		    style=
		    {{
		        marginBottom: "20px"
		    }}
		>

		    <label
		        style=
		        {{
		            marginRight: "10px",
		            fontWeight: "bold"
		        }}
		    >
		        Utilisation Survey
		    </label>

		    <select

		        value={utilisationSurveyId}

		        onChange=
		        {
		            function(event)
		            {
		                setUtilisationSurveyId(
		                    parseInt(
		                        event.target.value
		                    )
		                );
		            }
		        }

		        style=
		        {{
		            padding: "8px",
		            minWidth: "300px"
		        }}

		    >
				<option value={-100}>Select</option>
		        {

		            utilisationSurveys.map(

		                function(survey)
		                {

		                    return (

		                        <option

		                            key={survey.id}

		                            value={survey.id}

		                        >

		                            {survey.name}

		                        </option>

		                    );

		                }

		            )

		        }

		    </select>

		</div>

        <button onClick={handlePublishAll} style={buttonStyle} disabled={loading}>
          {loading ? "Publishing..." : "Publish Summary"}
        </button>
		<button onClick={handlePublishOrgs} style={buttonStyle} disabled={loading}>
          {loading ? "Publishing..." : "Publish Organisations"}
        </button>

        {loading && <div style={spinnerStyle} />}

        {message && (
          <div style={{ marginTop: "20px", fontWeight: "bold" }}>
            {message}
          </div>
        )}

      </div>

      {/* Spinner animation */}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>

    </div>
  );
}